import { render, staticRenderFns } from "./travel-insurance-trip-details.vue?vue&type=template&id=44aa6fff&scoped=true"
import script from "./travel-insurance-trip-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-trip-details.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-trip-details.vue?vue&type=style&index=0&id=44aa6fff&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa6fff",
  null
  
)

export default component.exports